import type { EnrichedSupplierForDelivery } from "../types";

/**
 * Maps a backend estimate (GET /v1/estimate or /v1/estimate/:estimateNo) to
 * the supplier splits the estimate modals render.
 */
export const mapEstimateToEnrichedSuppliers = (
  estimate: any,
): EnrichedSupplierForDelivery[] => {
  if (!estimate || !estimate.splits) return [];

  return estimate.splits.map((split: any) => {
    const parts = (split.items || []).map((item: any) => ({
      partId: item.partId,
      partNumber: item.partNumber,
      quantity: item.qty,
      requestedQty: item.requestedQty ?? item.qty,
      partName: item.partName,
      mrp: item.mrp,
    }));

    const deliveryOptions = (split.deliveryOptions || []).map(
      (option: any) => ({
        _id: option._id,
        cptSlab: option.cptSlab,
        cptMin: option.cptMin,
        cptMax: option.cptMax,
        deliveryCost: option.deliveryCost,
        vehicleType: split.vehicleType,
        vehicleTypeCosts: option.vehicleTypeCosts,
        deliveryCostDiscountPercentage: option.deliveryCostDiscountPercentage,
        deliveryMode: option.deliveryMode,
        payableBy: option.payableBy,
        payableTo: option.payableTo,
        isSystemGenerated: option.isSystemGenerated,
        cptAudit: option.cptAudit,
        minGaraazSlot: option.minGaraazSlot,
        maxGaraazSlot: option.maxGaraazSlot,
      }),
    );

    return {
      splitId: split._id ? String(split._id) : "",
      supplierId: split.supplierId ? String(split.supplierId) : null,
      supplierName:
        split.supplier?.businessName ||
        (split.supplierId ? "Unknown Supplier" : "Supplier Not Found"),
      distanceKm: undefined,
      supplierCity: split.supplier?.address?.city || undefined,
      parts,
      deliveryOptions,
      buyTime: split.buyTime != null ? String(split.buyTime) : undefined,
      vehicleType: split.vehicleType,
      transactionType: split.transactionType,
      discountPercentage: split.discountPercentage,
      creditNotePercentage: split.creditNotePercentage,
      fulfillmentStatus: split.fulfillmentStatus,
      payableBy: split.payableBy,
      payableTo: split.payableTo,
      status: split.status,
      confirmedDeliveryOptionId: split.confirmedDeliveryOptionId
        ? String(split.confirmedDeliveryOptionId)
        : undefined,
      deliveryType:
        split.deliveryType === "FASTEST" || split.deliveryType === "CHEAPEST"
          ? split.deliveryType
          : undefined,
      // Only GET /v1/estimate/:estimateNo populates them (pickup point choices).
      supplierOptions: Array.isArray(split.supplierOptions)
        ? split.supplierOptions
        : undefined,
    };
  });
};
